import { BadgeAccountAlertOutlineIcon } from './BadgeAccountAlertOutlineIcon';

/**
 * author: Michael Richins
 * id 3F5E356C-AD32-46E2-835F-ECFC043C73AD
 * name badge-account-alert-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/badge-account-alert-outline.svg
 * tags
 * - Account / User 
 * - Alert / Error 
 */
export const UserBadgeAlertOutlineIcon = BadgeAccountAlertOutlineIcon;
export default UserBadgeAlertOutlineIcon